export default {
    title: `Update in progress`,
    text: `An update is in progress. Please try reconnecting in few minutes.`,
};
